import { COMPARISONS } from './Conditional';
import { properties, PROPERTY_TYPES } from './properties';
const conditionalInputs = [
    {
        name: 'property',
        type: 'string',
        enum: properties,
    },
    {
        name: 'comparison',
        type: 'string',
        enum: [
            {
                label: COMPARISONS.isTrue,
                value: COMPARISONS.isTrue,
                helperText: PROPERTY_TYPES.boolean,
            },
            {
                label: COMPARISONS.isFalse,
                value: COMPARISONS.isFalse,
                helperText: PROPERTY_TYPES.boolean,
            },
            {
                label: COMPARISONS.equals,
                value: COMPARISONS.equals,
                helperText: `${PROPERTY_TYPES.string}, ${PROPERTY_TYPES.number}`,
            },
            {
                label: COMPARISONS.doesNotEqual,
                value: COMPARISONS.doesNotEqual,
                helperText: `${PROPERTY_TYPES.string}, ${PROPERTY_TYPES.number}`,
            },
            {
                label: COMPARISONS.contains,
                value: COMPARISONS.contains,
                helperText: `${PROPERTY_TYPES.string}, ${PROPERTY_TYPES.number}, ${PROPERTY_TYPES.array}`,
            },
            {
                label: COMPARISONS.doesNotContain,
                value: COMPARISONS.doesNotContain,
                helperText: `${PROPERTY_TYPES.string}, ${PROPERTY_TYPES.number}, ${PROPERTY_TYPES.array}`,
            },
            {
                label: COMPARISONS.startsWith,
                value: COMPARISONS.startsWith,
                helperText: `${PROPERTY_TYPES.string}, ${PROPERTY_TYPES.number}`,
            },
            {
                label: COMPARISONS.doesNotStartWith,
                value: COMPARISONS.doesNotStartWith,
                helperText: `${PROPERTY_TYPES.string}, ${PROPERTY_TYPES.number}`,
            },
            {
                label: COMPARISONS.endsWith,
                value: COMPARISONS.endsWith,
                helperText: `${PROPERTY_TYPES.string}, ${PROPERTY_TYPES.number}`,
            },
            {
                label: COMPARISONS.doesNotEndWith,
                value: COMPARISONS.doesNotEndWith,
                helperText: `${PROPERTY_TYPES.string}, ${PROPERTY_TYPES.number}`,
            },
        ],
    },
    {
        name: 'value',
        type: 'string',
    },
];
/** @deprecated - ConditionalVisibility should be used instead */
export const conditionalConfig = {
    hideFromInsertMenu: true,
    name: 'Conditional',
    category: 'Zapier Utilities',
    canHaveChildren: true,
    image: 'https://cdn.zappy.app/e9c121e6bf62dd6ff449979889283b46.png',
    inputs: [
        {
            name: 'conditions',
            helperText: 'If ANY condition is true, then the child block will be shown.',
            type: 'list',
            subFields: [
                ...conditionalInputs,
                {
                    name: 'and',
                    type: 'list',
                    subFields: [...conditionalInputs],
                },
            ],
        },
        { name: 'preview', type: 'boolean' },
    ],
};
//# sourceMappingURL=config.js.map